<template>
  <v-card outlined>
    <v-card-actions>
      <strong class="subtitle-1"><i>Special Scenarios</i></strong>
    </v-card-actions>
    <v-divider></v-divider>
    <v-card-text>
      <v-simple-table>
        <tbody>
        <tr v-for="special in specials" :key="special.uid" :class="special.$softDelete ? 'error lighten-2' : ''">
          <td>
            <v-text-field v-model="special.name" label="Display Name"></v-text-field>
          </td>
          <td>
            <v-autocomplete v-model="special.is_customer" :items="customers" item-text="primary_name.name" item-value="id" label="Customer(s)" clearable multiple></v-autocomplete>
          </td>
          <td>
            <v-select v-model="special.sample_category_uuid" :items="categories" item-text="name" item-value="uuid" label="Category"></v-select>
          </td>
          <td>
            <v-select v-model="special.has_tests" :items="testTypes" item-text="name" item-value="uuid" label="Has Tests" multiple></v-select>
          </td>
          <td>
            <v-select v-model="special.has_flags" :items="flagTypes" item-text="name" item-value="uuid" label="Has Flags" multiple></v-select>
          </td>
          <td>
            <v-radio-group v-model="special.is_addition" row>
              <v-radio label="Addition" :value="true"></v-radio>
              <v-radio label="Discount" :value="false"></v-radio>
            </v-radio-group>
          </td>
          <td>
            <v-text-field v-model="special.amount" label="Amount"></v-text-field>
          </td>
          <td class="text-center">
            <v-btn v-if="!special.$softDelete" color="error" outlined @click="remove(special)" small shaped ><v-icon>remove</v-icon></v-btn>
            <v-tooltip v-else bottom>
              <template v-slot:activator="{on}">
                <v-btn v-on="on" outlined @click="special.$softDelete = false" small shaped ><v-icon>undo</v-icon></v-btn>
              </template>
              <span>Undo deletion</span>
            </v-tooltip>
          </td>
        </tr>
        </tbody>
      </v-simple-table>
      <v-row justify="center">
        <v-btn class="success" @click="add" dark><v-icon>add</v-icon> Create Scenario</v-btn>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "BillingSnowFlake",
  components: {},
  data: () => ({
    loading: false,
    loadingError: false,
    specials: []
  }),
  props:{
    customers: {
      required: true,
    }
  },
  watch:{
    specials:{
      deep: true,
      handler(v){
        this.originalSpecials = v;
      }
    }
  },
  computed:{
    testTypes(){
      return this.$store.$db().model('sampleTestTypes').all()
    },
    categories(){
      return this.$store.$db().model('sampleCertTypeCategories').all()
    },
    flagTypes(){
      return this.$store.$db().model('sampleFlagTypes').all()
    },
    originalSpecials:{
      get(){
        return this.$store.$db().model('billingSpecials').all()
      },
      set(v){
        this.$store.$db().model('billingSpecials').insertOrUpdate({data: v});
      }
    }
  },
  mounted(){
    this.load();
  },
  methods: {
    async load(){
      this.loading = true;
      this.loadingError = false;
      await this.$store.$db().model('billingSpecials').load();
      this.reset();
    },
    add(){
      console.log('add')
      this.$store.$db().model('billingSpecials').add();
      this.reset();
    },
    remove(item){
      if(item.$isNew){
        item.$delete();
        this.reset();
      }else{
        item.$softDelete = true;
      }
    },
    reset(){
      this.specials = this.originalSpecials
    }
  }
}
</script>

<style scoped>

</style>
